import * as React from "react";
import { ReactElement } from "react";
import SeverityMark from "./SeverityMark";
import Report from "../commons/model/report/Report";
import { getSeveritySummary } from "../commons/model/treatment/SeveritySummary";
import SeverityChart from "./SeverityChart";
import reportComplexityBar from "../commons/components/ReportComplexityBar";
import { dateWithOptionalTime } from "../commons/utils/date";

interface AssessmentResultSummaryProps {
  report: Report;
  actions: ReactElement[];
  printMode?: boolean;
}

export default (props: AssessmentResultSummaryProps) => {
  const summary = getSeveritySummary(props.report.observations);
  const formattedDate = dateWithOptionalTime(props.report.creation);
  return (
    <div className="panel summary h-flex space-between align-center no-wrap">
      <div className="v-flex">
        <div className="assessment-result-info h-flex with-separator">
          <span className="date no-padding-top-bottom">{formattedDate}</span>
          {props.report.clinicalScore !== null &&
            props.report.clinicalScore !== undefined &&
            props.report.displayClinicalScore && (
              <div className={"h-flex with-margins no-padding-top-bottom"}>
                <span>{i18n["Page.PatientManagement.LastReport.Complexity"]}</span>
                {reportComplexityBar(props.report.reportComplexity)}
              </div>
            )}
        </div>
        {summary.length > 0 && (
          <div className="h-flex with-margins summary-info">
            <SeverityChart pieSize={125} summary={summary} />
            <div className="legend v-flex space-around">
              {[...summary].reverse().map((severity) => (
                <div key={severity.type} className="h-flex group align-center">
                  <SeverityMark severity={severity.type} printMode={props.printMode} />
                  <span>
                    <strong>{severity.total}</strong>
                  </span>
                  <span>&nbsp;{severity.label}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="actions v-flex space-around">{props.actions}</div>
    </div>
  );
};
